import TextEditor from "./components/TextEditor";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom'
import { v4 as uuidV4 } from 'uuid'
import NavBar from "./components/NavBar";
import About from "./components/About";
import Home from "./pages/Home";


function App() {
  return (
    <Router>
      <Switch>

        <Route path="/" exact>
          <Redirect to={`/document/${uuidV4()}`} />
        </Route>

        <Route path="/documents">
          <NavBar />
          <Home />
        </Route>

        <Route path="/document/:id">
          <NavBar /> 
          <TextEditor />
        </Route>

        <Route path="/about">
          <NavBar />
          <About />
        </Route>

      </Switch>
    </Router>
  );
}

export default App;
